import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
 
export const getCostUploadHistory = async (params) => {
   
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    let queryParams = new URLSearchParams(params).toString();
    const apiUrl = localDatabaseUrls.baseURL + localDatabaseUrls.serviceURL.costUploadHistory + (queryParams ? "?" + queryParams : "")
   
    // const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.costUploadHistory}?page=0`;
     const response = await getAPI(apiUrl, tokenInfo);
    
 
    if (response.status === 200 || response.status === 201) {
        return response.json();
    } else {
        console.error("Error while getting cost upload history:", response.statusText);
        return { content: [], totalPages: 0 };
    }
 
};

export const getCostUploadHistoryForCjwDiBatch = async (batchId) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return [];
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiBatchCostFiles}/${encodeURIComponent(batchId)}`;
    const response = await getAPI(apiUrl, tokenInfo);

    if (response.ok) {
        const payload = await response.json().catch(() => []);
        return Array.isArray(payload) ? payload : [];
    }

    console.error("Error while getting cost upload history for batch:", response.statusText);
    return [];
};

export const getCostUploadHistoryForDcBatch = async (batchId) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return [];
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcBatchCostFiles}/${encodeURIComponent(batchId)}`;
    const response = await getAPI(apiUrl, tokenInfo);

    if (response.ok) {
        const payload = await response.json().catch(() => []);
        return Array.isArray(payload) ? payload : [];
    }

    console.error("Error while getting cost upload history for DC batch:", response.statusText);
    return [];
};
